import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { AdminTokenService } from '../services/admin-token.service';

/**
 * Guard สำหรับ /admin/account — ถ้า admin login อยู่แล้วให้ redirect
 * ไปยัง returnUrl (ถ้ามี) หรือ /admin/users เป็น default
 * Skip ฝั่ง SSR (client ค่อยตรวจหลัง hydrate)
 */
export const alreadyLoggedAdminGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const platformId = inject(PLATFORM_ID);
  if (!isPlatformBrowser(platformId)) return true;

  const tokenSvc = inject(AdminTokenService);
  const router   = inject(Router);

  if (!tokenSvc.isExpired()) {
    const returnUrl = route.queryParamMap.get('returnUrl');
    // กัน open redirect — รับเฉพาะ path ภายใน /admin/* ที่ไม่ใช่ /admin/account
    const safe = returnUrl && returnUrl.startsWith('/admin/') && !returnUrl.startsWith('/admin/account')
      ? returnUrl
      : '/admin/users';
    return router.parseUrl(safe);
  }
  return true;
};
